import React, {useEffect, useState} from 'react';
import {ChartBar, ClipboardText, Fire, Lightning, Table} from '@phosphor-icons/react';
import {Note, Tab} from '../../../../components';
import ModuleProperties from './ModuleProperties';
import IrradiancePopup from '../Irradiance/IrradiancePopup';
import RoofInformationTabIpad from "./I-Pad Tabs/RoofInformationTabIpad";
import { isIpadDevice } from '../../../../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/Common';
import ProductionTabIpad from "./I-Pad Tabs/ProductionTabIpad";
import ChartsTabIpad from "./I-Pad Tabs/ChartsTabIpad";
import {useViewerStore} from "../../../../store/store";
import { TabItem } from '../../../../@types/types';

const Modules: React.FC = () => {
    const sceneViewer = useViewerStore(state => state.sceneViewer);

    const [items, setItems] = useState<TabItem[]>([{
        icon: (<ClipboardText size={24} weight='fill'/>),
        content: (<ModuleProperties/>),
        title: 'Module Properties',
        is_active: true,
    }])

    useEffect(() => {
        const itemsClone = [...items]

        if (isIpadDevice()) {

            itemsClone.push({
                id: 'btnSystemSummary',
                icon: (<Table size={24} weight='fill'/>),
                content: (<RoofInformationTabIpad/>),
                title: 'System Summary',
                is_active: false,
            })


            itemsClone.push({
                icon: (<Lightning size={24} weight='fill'/>),
                content: (<ProductionTabIpad/>),
                title: 'Total System',
                is_active: false,
            })

            itemsClone.push({
                icon: (<ChartBar size={24} weight='fill'/>),
                content: (<ChartsTabIpad/>),
                title: 'Solar Access System',
                is_active: false,
            })
            setItems(itemsClone)
        }

        if (sceneViewer) sceneViewer.setTabInfo('Module Properties');
    }, []);


    return (
        <>
            <Tab items={items}/>
            <IrradiancePopup isOpenByDefault={false} />
            
            <Note
                title='Setback Notes'
                icon={<Fire size={19} weight="fill"/>}
            />
        </>
    );
}

export default Modules;